<div class="bg-background flex min-h-svh items-center justify-center px-4 py-8">
  <div
    class="auth-card bg-card text-card-foreground w-full max-w-[26rem] rounded-xl border-[1px] p-6 shadow-[0_1px_3px_0_rgb(0_0_0/0.1)] sm:p-8"
  >
    <img src="assets/images/logo.png" alt="VAPT" class="mx-auto mb-8 h-8 w-auto" />

    <div class="mb-6 flex items-center justify-between gap-3">
      <h1 class="mb-0 text-xl font-semibold tracking-tight">{{ 'LOGIN.TITLE' | translate }}</h1>

      <button
        type="button"
        hlmBtn
        variant="outline"
        size="sm"
        class="gap-1.5"
        [hlmDropdownMenuTrigger]="langMenu"
        align="end"
        [attr.aria-label]="'SETTINGS.LANGUAGE' | translate"
      >
        <img
          [src]="selectedLang.flag"
          alt=""
          class="size-4 rounded-full object-cover"
          (error)="onFlagError($event)"
        />
        <ng-icon name="lucideChevronDown" class="text-muted-foreground" />
      </button>

      <ng-template #langMenu>
        <div hlmDropdownMenu class="w-44">
          @for (l of languages; track l.code) {
            <button
              type="button"
              hlmDropdownMenuItem
              [attr.aria-label]="('LANGUAGE.OPTION.' + l.code) | translate"
              (click)="changeLanguage(l.code)"
            >
              <img [src]="l.flag" alt="" class="size-4 rounded-full object-cover" (error)="onFlagError($event)" />
              <span class="flex-1">{{ ('LANGUAGE.OPTION.' + l.code) | translate }}</span>
              @if (currentLang === l.code) {
                <ng-icon name="lucideCheck" />
              }
            </button>
          }
        </div>
      </ng-template>
    </div>

    <form [formGroup]="form" (ngSubmit)="login()" class="flex flex-col gap-5">
      <div class="ui-field">
        <label class="ui-label" for="email">{{ 'LOGIN.EMAIL_LABEL' | translate }}</label>
        <input
          class="ui-input h-10"
          id="email"
          type="email"
          maxlength="255"
          [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate"
          formControlName="email"
          autocomplete="username"
          [attr.aria-invalid]="emailCtl?.invalid && emailCtl?.touched ? 'true' : null"
          [attr.aria-describedby]="emailCtl?.invalid && emailCtl?.touched ? 'email-error' : null"
        />
        @if (emailCtl?.invalid && emailCtl?.touched) {
          <p id="email-error" class="ui-field-error" role="alert">
            @if (emailCtl?.hasError('required')) {
              {{ 'LOGIN.EMAIL_REQUIRED' | translate }}
            } @else if (emailCtl?.hasError('maxlength')) {
              {{ 'LOGIN.EMAIL_TOO_LONG' | translate }}
            } @else if (emailCtl?.hasError('email') || emailCtl?.hasError('pattern')) {
              {{ 'LOGIN.EMAIL_INVALID' | translate }}
            }
          </p>
        }
      </div>

      <div class="ui-field">
        <label class="ui-label" for="password">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
        <div class="ui-input-group h-10">
          <input
            class="ui-input-group-control"
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
            formControlName="password"
            autocomplete="current-password"
            [attr.aria-invalid]="passwordCtl?.invalid && passwordCtl?.touched ? 'true' : null"
            [attr.aria-describedby]="passwordCtl?.invalid && passwordCtl?.touched ? 'password-error' : null"
          />
          <div class="ui-input-group-addon ui-input-group-addon-end">
            <button
              type="button"
              hlmBtn
              variant="ghost"
              size="icon-sm"
              class="rounded-md border-0 p-0 shadow-none"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="(showPassword ? 'LOGIN.HIDE_PASSWORD' : 'LOGIN.SHOW_PASSWORD') | translate"
            >
              <ng-icon [name]="showPassword ? 'lucideEye' : 'lucideEyeOff'" />
            </button>
          </div>
        </div>
        @if (passwordCtl?.invalid && passwordCtl?.touched) {
          <p id="password-error" class="ui-field-error" role="alert">
            @if (passwordCtl?.hasError('required')) {
              {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
            }
          </p>
        }
      </div>

      <button type="submit" hlmBtn size="lg" class="h-10 w-full hover:brightness-90" [disabled]="loading">
        @if (loading) {
          <ng-icon name="lucideLoader2" class="animate-spin" />
        }
        <span>{{ (loading ? 'LOGIN.SUBMIT_LOADING' : 'LOGIN.SUBMIT') | translate }}</span>
      </button>

      <div class="text-muted-foreground flex items-center gap-3 text-xs uppercase">
        <div class="ui-separator flex-1" role="separator"></div>
        <span>{{ 'LOGIN.DIVIDER_OR' | translate }}</span>
        <div class="ui-separator flex-1" role="separator"></div>
      </div>

      <div class="relative flex flex-col gap-3">
        <app-google-login-button
          class="block"
          [autoWidthSelector]="'.auth-card'"
          (credential)="onGoogleCredential($event)"
        ></app-google-login-button>

        <app-apple-login-button class="block" (credential)="onAppleCredential($event)"></app-apple-login-button>
      </div>
    </form>
  </div>
</div>
